import { render, staticRenderFns } from "./AwardInformation.vue?vue&type=template&id=6f3f947e&scoped=true"
import script from "./AwardInformation.vue?vue&type=script&lang=js"
export * from "./AwardInformation.vue?vue&type=script&lang=js"
import style0 from "./AwardInformation.vue?vue&type=style&index=0&id=6f3f947e&prod&lang=less&scoped=true"
import style1 from "./AwardInformation.vue?vue&type=style&index=1&id=6f3f947e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3f947e",
  null
  
)

export default component.exports